import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import {PopUpContext} from "../../contexts/popUpContext";

class StudentClassInfoForm extends Form {
    static contextType = PopUpContext;

    state = {
        drp: {
            faculty: [],
            time: [],
            department: [],
        },
        data: {
            selected_faculty_id: "",
            selected_time_id: "",
            selected_department_id: "",
        },
        errors: {},
    };

    componentDidMount = async () => {
        const {drp, data} = this.state;

        const {
            popUp: {cache, edit},
        } = this.context;

        if (edit) {
            data.selected_faculty_id = edit.selected_faculty_id;
            data.selected_faculty_id = edit.selected_faculty_id;
            data.selected_time_id = edit.selected_time_id;
            data.selected_department_id = edit.selected_department_id;
        }

        await db
            .getAll(`dropdowns/faculties`)
            .then(({data: {data}}) => (drp["faculty"] = data));

        await db
            .getAll(`dropdowns/times`)
            .then(({data: {data}}) => (drp["time"] = data));

        if (data.selected_faculty_id) {
            const faculty_id = data.selected_faculty_id;
            await db
                .getAll(`dropdowns/departments`)
                .then(({data: {data}}) => (drp["department"] =
                    data.filter((department) => department.faculty === faculty_id)));
        }

        this.setState({drp, data});
    };

    schema = {
        selected_faculty_id: Joi.number(),
        selected_time_id: Joi.number(),
        selected_department_id: Joi.number().allow('').allow(null),
    };

    doSubmit = async (e) => {
        const {togglePopUp, popUp} = this.context;
        const student_id = popUp.student.student_id;

        let __controls = this.cleanObject({
            student_id: popUp?.cache,
            ...this.state.data,
        });

        try {
            if (popUp?.edit?.id) {
                await db
                    .edit(`students/${student_id}/info/${popUp.edit.id}`, __controls)
                    .then(() => {
                        togglePopUp({form: "toast"});
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            } else {
                await db
                    .save(`students/${student_id}/info`, __controls)
                    .then(() => {
                        togglePopUp({form: "toast"});
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            }
            if (popUp.callback) popUp.callback();
        } catch ({response}) {
            if (response && response.status === 400) {
                const errors = {...this.state.error};

                this.setState({errors});
            }
        }
    };


    reloadDepartments = async (e) => {
        const {data, drp} = this.state;

        data.selected_faculty_id = e.data.id
        const faculty_id = data.selected_faculty_id;

        // reset old values
        data.selected_department_id = null;
        drp.department = []

        await db
            .getAll(`dropdowns/departments`)
            .then(({data: {data}}) => (drp["department"] =
                data.filter((department) => department.faculty === faculty_id)));

        this.setState({data, drp});
    };

    render() {
        const {data, drp} = this.state;
        const {popUp} = this.context;

        return (
            <div className="form-container">
                <form className="form crud" onSubmit={this.handleSubmit}>
                    <div className="head">
                        <p>{popUp?.edit ? lbl.EditStudentClassInfo : lbl.AddStudentClassInfo}</p>
                    </div>
                    <div className="form-inputs">
                        {this.renderSelect("selected_faculty_id", "رشته", drp["faculty"], false, this.reloadDepartments)}
                        {this.renderSelect("selected_department_id", "دپارتمنت", drp["department"])}
                        {this.renderSelect("selected_time_id", "دوره", drp["time"])}
                    </div>
                    <div className="form-buttons">
                        {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
                    </div>
                </form>
            </div>
        );
    }
}

export default StudentClassInfoForm;
